import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormNumericField } from './KioskFormNumericField/KioskFormNumericField';
import { WebFormNumericField } from './WebFormNumericField/WebFormNumericField';
import { FormNumericFieldProps } from './FormNumericField.types';

const FormNumericField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.NumberPad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
}: FormNumericFieldProps) => {
    return (
        isElectron() ? (
            <KioskFormNumericField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                shiftAfterAmpersand={shiftAfterAmpersand}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
            />
        ) : (
            <WebFormNumericField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
            />
        )
    );
},
);

export default FormNumericField;
